<template>
<div>
  <div class="m-background m-background--graph"></div>
  <div class="m-promotion">
    <h2 class="m-promotion__title">Mission Accomplished</h2>
    <div class="u-align--center">
      <img class="v-media" src="~@/assets/images/characters/welcome-to-bright-city.svg" />
    </div>
    <h2 class="m-promotion__title">Great Job</h2>
    <a @click="progress()" class="m-btn m-btn__secondary m-btn--right"></a>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '../components/header/Header';

export default {
  components: {
    Header,
  },
  computed: {
    ...mapGetters(['getBudget']),
  },
  methods: {
    progress() {
      this.$router.push({ name: 'confidence' });
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-media {
    width: 300px;
    margin: 0 auto 50px auto;
  }
</style>




// WEBPACK FOOTER //
// src/views/CompletedLevels.vue